import Vue from 'vue'

import moment from 'moment'
// import your Vuex store object
import { store } from './store/store'

/*
|--------------------------------------------------------------------------
| Format price to a currency & prefix with euro symbol
|--------------------------------------------------------------------------
*/
Vue.filter('price', (price) => {
  if (!price) return ''
  return new Intl.NumberFormat('nl-NL', {
    style: 'currency', currency: 'EUR'
  }).format(parseFloat(price))
})

/*
|--------------------------------------------------------------------------
| Format delivery date to a nice format, e.g. Maandag 5 maart 2019
|--------------------------------------------------------------------------
*/
Vue.filter('deliveryDate', (deliveryDate) => {
  if (!deliveryDate) return ''

  moment.locale('nl')
  // Get our formatted date
  let formatted = moment(deliveryDate, 'YYYY-MM-DD').format('dddd D MMMM YYYY')
  // Uppercase first letter
  return formatted.charAt(0).toUpperCase() + formatted.slice(1)
})

/*
|--------------------------------------------------------------------------
| Material name, combine type, core & thickness
|--------------------------------------------------------------------------
*/
Vue.filter('materialName', (material) => {
  if (material.filterFirst) {
    if (material.filterSecond) {
      if (material.thickness) {
        return material.filterFirst + ' ' + material.filterSecond + ', ' + material.thickness + 'mm'
      } else {
        return material.filterFirst + ' ' + material.filterSecond
      }
    } else {
      return material.filterFirst
    }
  }

  return ''
})

/*
|--------------------------------------------------------------------------
| Material short name, combine type & core
|--------------------------------------------------------------------------
*/
Vue.filter('materialNameShort', (material) => {
  if (material.filterFirst) {
    if (material.filterSecond) {
      return material.filterFirst + ' ' + material.filterSecond
    } else {
      return material.filterFirst
    }
  }

  return ''
})

/*
|--------------------------------------------------------------------------
| Material width
|--------------------------------------------------------------------------
*/
Vue.filter('materialWidth', (material) => {
  if (material.thickness) {
    if (material.finish && material.finish.name !== 'Geen' && material.finish.name !== 'Niet mogelijk') {
      return material.thickness + 'mm' + ' + ' + material.finish.name
    } else {
      return material.thickness + 'mm'
    }
  }

  return ''
})

/*
|--------------------------------------------------------------------------
| Material description, combine material sides
|--------------------------------------------------------------------------
*/
Vue.filter('materialDescription', (material) => {
  // Check sides
  let side1 = store.getters.side(material.side1)

  if (side1) {
    let side2 = store.getters.side(material.side2)
    if (side2) {
      return side1.description + ' + ' + side2.description
    } else {
      return side1.description
    }
  }

  return ''
})
